import React from 'react';
import PropTypes from 'prop-types'
import StatisticsByReferralContentComponent from './StatisticsByReferralContent/StatisticsByReferralContent.container';
import { withRouter } from '../../RouterCompatibility';

class StatisticsByReferralPage extends React.Component {
    render() {
        const staticNames = this.context.t.reportPage;

        return (
            <div className="dashboard dashboard_consolidated-report">
                <div className="page-heading">
                    <div className="page-heading__inner">
                        <h2>{staticNames.titleByReferral}</h2>
                    </div>
                </div>

                <StatisticsByReferralContentComponent
                    location={this.props.location}
                />
            </div>
        );
    }
}

StatisticsByReferralPage.contextTypes = {
    t: PropTypes.object
};

export default withRouter(StatisticsByReferralPage);
